'use strict';

export default {
  optionsWrapper: {
    delete: {
      errorRule: "You can't delete a field used inside a rule. Please change your rules before deleting this field.",
      confirmation: 'Are you sure you want to delete this field?',
    },
  },
  multiSteps: {
    cancel: 'Cancel',
    save: 'Save',
    addStep: 'Add New Step',
    editStep: 'Edit Step',
    stepName: 'Step Name',
    deleteStep: 'Delete this step?',
    delete: 'Delete',
    deleteModalHeader: 'Attention!',
    deleteConfirmation: 'Are you sure you want to delete this step?',
    deleteRule:
      "You can't delete a step when one or more of its associated fields are used in rules. Please check your rules before deleting.",
  },
  multiSections: {
    cancel: 'Cancel',
    save: 'Save',
    addSection: 'Add New Section',
    multiple: 'Multiple',
    sectionMultiple: 'Multiple section',
    editSection: 'Edit Section',
    sectionName: 'Section Name',
    deleteSection: 'Delete this section?',
    delete: 'Delete',
    deleteModalHeader: 'Attention!',
    deleteConfirmation: 'Are you sure you want to delete this section?',
    deleteRule:
      "You can't delete a section when one or more of its associated fields are used in rules. Please check your rules before deleting.",
    changeToMultiple:
      "You can't change a section to multiple when one or more of its associated fields are used in rules.",
  },
};
